@if (pageConfig) {
  <div class="card">
    <app-grid-server-side
      [storageKey]="pageConfig.storageKey"
      [loading]="isLoading()"
      [defaultExcelExportParams]="excelExportParams"
      [excelStyles]="excelStyles"
      [colDefs]="$any(colDefs())"
      [rowData]="[]"
      [pinFirstColumnName]="pinFirstColumnName"
      [totalRows]="totalRecords()"
      [gridOptions]="gridOptions"
      [pageTitle]="pageConfig.pageTitle"
      [suppressRowClickSelection]="true"
      [serverSideDatasource]="dataSource()"
      [paginationPageSize]="defaultPageSize"
      [cacheBlockSize]="cacheBlockSize"
      (gridReady)="onGridReady($event)"
      (select)="selectAnnualStatements($event)"
      (search)="onSearch($event)"
    >
      <div class="grid-controls-end d-flex justify-content-end gap-12" *appHasRole="['Admin', 'Manager', 'Preparer']">
        @if (checkedAnnualStatements.length) {
          <div
            ngbDropdown
            class="dropdown"
            [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
          >
            <app-button
              ngbDropdownToggle
              id="bulk-actions-dd"
              text="Actions"
              iconClass="icon ic-select-20"
              [iconLast]="true"
            />
            <!--            [isDisabled]="modalOpened()"-->
            <div
              ngbDropdownMenu
              aria-labelledby="bulk-actions-dd"
              class="common-dropdown-menu dropdown-menu dropdown-menu-right"
            >
              @for (item of bulkMenuActionItems; track $index) {
                <button ngbDropdownItem (click)="item.action()">
                  {{ item.title }}
                </button>
              }
            </div>
          </div>
        } @else {
          <app-button
            title="Export"
            btnColor="white"
            iconClass="icon ic-download-20"
            [isDisabled]="!records().length"
            (clickBtn)="exportAnnualList(false, ExportTypeEnum.EXCEL)"
          />
          <!--          [isDisabled]="!records().length || modalOpened()"-->
        }
      </div>
    </app-grid-server-side>
  </div>

}
